/**
 * Whether the user may use the admin panel (admin mode) and reach the
 * dashboard without an organization: staff, superusers and moderators.
 *
 * Moderators are recognised by `is_moderator` on the profile user, or by the
 * `moderator` block stored at login (sent even when the user has no
 * organization). Their pages are still gated by moderator permissions.
 */
export function hasAdminAccess(user: any): boolean {
  const userData = user?.user || user;
  if (userData?.is_staff || userData?.is_superuser || userData?.is_admin || userData?.is_moderator) {
    return true;
  }
  return isStoredModerator();
}

function isStoredModerator(): boolean {
  const stored = localStorage.getItem('moderator');
  if (!stored) return false;

  try {
    return !!JSON.parse(stored)?.is_moderator;
  } catch {
    return false;
  }
}
